import React from 'react';
import './index.scss';

export default function NoState(props) {
  return (
    <div className={['no-state', props.card ? 'no-state-card' : ''].join(' ')}>
      <div className="no-state__icon"></div>
      <div className="no-state__desc">{props.text}</div>
    </div>
  );
}
